import {CreativeBean} from 'common/api/api'
import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps, enumToLabelValue} from './DictionarySelector'

export const CreativeStatusSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="creativeStatus"
                        loader={() => enumToLabelValue(CreativeBean.StatusEnum)}
    />